import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TodoService } from '../../services/todo.service';

@Component({
  selector: 'app-todolist',
   templateUrl: './todolist.component.html',
  styleUrl: './todolist.component.css'
})
export class TodolistComponent implements OnInit, OnDestroy {

  @Input()
  modalWindow:any;

  @Input()
  list:any;

  remainingSeconds = 10;  //secondi
  closeTimeoutId: any;
  private countdownIntervalId: any;

  constructor(private todoservice:TodoService){}

  ngOnInit(): void {
    this.closeTimeoutId = setTimeout(() => this.close(), this.remainingSeconds*1000);
    this.countdownIntervalId = setInterval(() => {
      this.remainingSeconds = Math.max(0, this.remainingSeconds - 1);
    }, 1000);
  }

  ngOnDestroy(): void {
    this.clearCountdown();
  }

  close(){
    this.modalWindow.close();
  }

  private clearCountdown(): void {
    if (this.closeTimeoutId) {
      clearTimeout(this.closeTimeoutId);
      this.closeTimeoutId = null;
    }
    if (this.countdownIntervalId) {
      clearInterval(this.countdownIntervalId);
      this.countdownIntervalId = null;
    }
  }

  changeState(record:any,state:any){
    this.clearCountdown();
    record.state=state;
    this.todoservice.save(record,()=>{

    });
  }




}
